import React from 'react';
import Card from "../../../../Utilities/Card";
import { issuerOf, monogramOf } from '../../../../../Utils/certIssuer';

const Component = ({ exam, time }) => {
  const issuer = issuerOf(exam || '');

  return (
    <Card
      icon={
        <div className={issuer.light ? "tile light fcc" : "tile fcc"}>
          {issuer.logo ? <img src={issuer.logo} alt={issuer.name} /> : <b>{monogramOf(exam || '')}</b>}
        </div>
      }
      title={exam}
      meta={[issuer.name, time].filter(Boolean).join(' · ')}
    />
  )
}

export default Component
